import React from 'react';
import './SkeletonCard.css'; // Import the CSS for skeleton styling

const SkeletonCard = () => {
  return (
    <div className="skeleton-card">
      {/* <div className="skeleton-image" /> */}
      <div className="skeleton-content">
        <div className="skeleton-line skeleton-title" />
        <div className="skeleton-line skeleton-text" />
        <div className="skeleton-line skeleton-text" />
      </div>
    </div>
  );
};

export default SkeletonCard;
